import resourceApi from "@/apis/ResourceApi";

const resourceService = {
  async getResources(pointId, servicesIds) {
    return await resourceApi.getResources(pointId, servicesIds);
  },
}

export default resourceService;